import React from 'react'

export default function InfluencerSignupSuccess() {
  return (
    <div className="flex flex-col min-h-screen w-screen items-center justify-center">
      <h1 className="text-2xl font-bold uppercase">Thank you for submitting your profile!</h1>
      <p>We will contact you if there are suitable campaigns for you.</p>
      <a href="https://www.reachbird.io/en/" className="mt-1 px-2 py-1 bg-rb-green text-white rounded-md">Back to site</a>
    </div>
  )
}